import { apiRequest } from './client'

export interface Project {
  id: string
  owner_user_id: string
  slug: string
  name: string
  description: string | null
  visibility: 'private' | 'public'
  is_shared: boolean
  shared_at: string | null
  created_at: string
  updated_at: string
}

export interface CreateProjectInput {
  slug: string
  name: string
  description?: string
  visibility?: 'private' | 'public'
}

export interface UpdateProjectInput {
  name?: string
  description?: string | null
  visibility?: 'private' | 'public'
  is_shared?: boolean
}

export async function listProjects(): Promise<Project[]> {
  return apiRequest<Project[]>('/api/projects')
}

export async function getProject(id: string): Promise<Project> {
  return apiRequest<Project>(`/api/projects/${id}`)
}

export async function createProject(input: CreateProjectInput): Promise<Project> {
  return apiRequest<Project>('/api/projects', { method: 'POST', body: input })
}

export async function updateProject(id: string, input: UpdateProjectInput): Promise<Project> {
  return apiRequest<Project>(`/api/projects/${id}`, { method: 'PATCH', body: input })
}

export async function deleteProject(id: string): Promise<void> {
  return apiRequest<void>(`/api/projects/${id}`, { method: 'DELETE' })
}
